import 'altcha'
import 'altcha/i18n/de'
import 'altcha/i18n/en'
import 'altcha/i18n/it'
import 'altcha/i18n/fr-fr'

class OiForm {
    private oiFormElement: HTMLElement | null
    private formElement: HTMLFormElement | null
    private successMessageElement: HTMLElement | null
    private missingRequiredFieldsMessageElement: HTMLElement | null
    private sendingMessageElement: HTMLElement | null
    private errorMessageElement: HTMLElement | null
    private submitElement: HTMLFormElement | null
    private honeyPotElement: HTMLFormElement | null

    constructor(oiFormElement: HTMLElement) {
        console.log('OiForm: Constructor')
        this.oiFormElement = oiFormElement

        this.submitElement = this.oiFormElement.querySelector('input[type="submit"]')
        this.formElement = this.oiFormElement.querySelector('form')
        if (this.formElement && this.submitElement) {
            this.successMessageElement = this.oiFormElement.querySelector('.js-form-message-success') || null
            this.sendingMessageElement = this.oiFormElement.querySelector('.js-form-message-sending') || null
            this.errorMessageElement = this.oiFormElement.querySelector('.js-form-message-error') || null
            this.missingRequiredFieldsMessageElement = this.oiFormElement.querySelector('.js-missing-required-fields') || null

            //Clear honeypot
            this.honeyPotElement = this.oiFormElement.querySelector('.js-honey-pot') as HTMLFormElement
            this.clearHoneyPot()

            // Disable default browser validation pop-ups to allow for custom styling.
            this.formElement.setAttribute('novalidate', 'true')

            //Form submission
            this.formElement.addEventListener('submit', this.handleSubmit.bind(this))
        } else {
            console.log('OiForm: Form or Submit missing')
        }
    }

    clearHoneyPot() {
        if (this.honeyPotElement) {
            this.honeyPotElement.value = ''
        }
    }

    private hideMissingRequiredFieldsMessage() {
        if (this.missingRequiredFieldsMessageElement) {
            this.missingRequiredFieldsMessageElement.classList.add('hidden')
        }
    }

    private async handleSubmit(event: Event) {
        event.preventDefault()

        const useBrowserValidation = this.oiFormElement.dataset.validation === 'browser'

        if (useBrowserValidation) {
            if (!this.formElement.reportValidity()) {
                this.showMissingRequiredFieldsMessage()
                return
            }
        } else {
            if (!this.formElement.checkValidity()) {
                this.formElement.classList.add('form-submitted')
                this.showMissingRequiredFieldsMessage()
                return
            }
        }

        this.hideMissingRequiredFieldsMessage()
        this.formElement.classList.remove('form-submitted')

        console.log('OiForm: handleSubmit')

        // Display sending message
        this.showSendingMessage()

        // Get form data
        const formData = new FormData(this.formElement)

        // Get the form action URL
        const formAction = this.formElement.getAttribute('action') || ''

        try {
            const response = await fetch(formAction, {
                method: 'POST',
                body: formData,
            })

            if (response.ok) {
                this.showSuccessMessage()
            } else {
                this.showErrorMessage()
            }
        } catch (error) {
            console.error('Error during form submission:', error)
            this.showErrorMessage()
        }
    }

    private showSendingMessage() {
        if (this.sendingMessageElement) {
            this.sendingMessageElement.classList.remove('hidden')
        }
        this.submitElement.setAttribute('disabled', 'disabled')
    }

    private showSuccessMessage() {
        if (this.sendingMessageElement) {
            this.sendingMessageElement.classList.add('hidden')
        }
        if (this.successMessageElement) {
            this.successMessageElement.classList.remove('hidden')
        }
    }

    private showErrorMessage() {
        if (this.sendingMessageElement) {
            this.sendingMessageElement.classList.add('hidden')
        }
        if (this.errorMessageElement) {
            this.errorMessageElement.classList.remove('hidden')
        }
    }

    private showMissingRequiredFieldsMessage() {
        if (this.sendingMessageElement) {
            this.sendingMessageElement.classList.add('hidden')
        }
        if (this.missingRequiredFieldsMessageElement) {
            this.missingRequiredFieldsMessageElement.classList.remove('hidden')
        }
    }
}

export default OiForm